const useStyles = ({ theme, fullScreem, colorAlert }) => ({
  line: {
    backgroundColor: colorAlert,
    height: "60%",
    width: "3px",
    ml: "7px",
    mr: "-5px",
  },

  card: {
    borderRadius: "5px",
    backgroundColor: theme.palette.background.paperSelectedMaps,
    boxShadow: "0px 0px 3px  #0000001a",
    border: "none",
    "&::before": {
      display: "none",
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
  },

  drawer: {
    position: "absolute",
    clipPath: "none",
    marginTop: "65px",
    flexShrink: 0,
    overflow: "auto",
    "& .MuiDrawer-paper": {
      zIndex: 1203,
      //boxShadow: "0px 0px 10px  #0000001a",
      borderRadius: "7px",
      color: theme.palette.text.primary,
      mr: "10px",
      height: fullScreem
        ? { xs: "calc(100vh - 50px)", sm: "calc(100vh - 20px)" }
        : { xs: "calc(100vh - 120px)", sm: "calc(100vh - 85px)" },
      width: "350px",
      padding: "0px 15px",
      marginTop: fullScreem ? "10px" : "70px",
      overflow: "visible",
      overflowY: "auto",
      backgroundColor: theme.palette.background.sideBar,
      border: "1px solid " + theme.palette.color.appBarBorder,
    },
  },
  stackContainerSvg: {
    position: "absolute",
    top: 0,
    left: "-28px",
    width: fullScreem ? "100vw" : "100%",
    height: fullScreem ? "100vh" : "calc(100vh - 70px)",
    zIndex: -1,
    background: "none",
    justifyContent: "center",
    backgroundColor: "red",
  },
  satckSvg: {
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
  },
  iconButton: {
    position: "absolute",
    "&:hover": {
      borderColor: "none",
      boxShadow: "none",
      background: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "none",
      borderColor: "none",
      background: "none",
    },
    "&:focus": {
      boxShadow: "none",
      backgroundColor: "none",
      borderColor: "none",
      background: "none",
    },
  },
  buttonHide: {
    height: "200px",
    width: "30px",
    fill: theme.palette.background.sideBar,
  },
  icon: {
    width: "20px",
    height: "20px",
    pl: "2px",
  },
  textMedium: { color: theme.palette.color.textDisabled },
  textLarge: { fontSize: "2em" },
  contentTab: {
    gap: 1,
    maxHeight: fullScreem ? "68vh" : "60.5vh",
    boxSizing: "content-box", // Garante que o padding seja incluído
    paddingRight: "0.4rem", // Espaço para o scrollbar
  },
  detailsCard: {
    backgroundColor: theme.palette.background.paperLinkedMaps,
    paddingX: "10px",
    paddingY: "15px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  rowsDetails: { alignItems: "center", justifyContent: "space-between" },
  text: {
    fontSize: "0.875rem",
    color: theme.palette.color.text,
    //textTransform: "none",
  },
  data: {
    overflow: "auto",
    height: "100%",
    paddingBottom: "15px",
  },
  tabs: {
    width: "100%",
    minHeight: "20px",
    "& button": {
      color: theme.palette.text.disabled,
      textTransform: "none",
      minHeight: "20px",
      Height: "100%",
      borderRadius: "5px",
      paddingX: "10px",
    },
    "& .MuiTab-icon": { marginRight: "2px" },
    "& button.Mui-selected": {
      backgroundColor: theme.palette.background.tab,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      border: "none",
    },
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  iconUserNotFound: {
    width: "140px",
    height: "140px",
    fill: theme.palette.text.disabled,
  },
});
export default useStyles;
